import React, { useState } from 'react'
import TreeView from './TreeView'
import { AccordionArrow } from './Icons'

function Accordion({data, item, index}) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className={`${!isOpen && 'md:hover:bg-gray-100'} w-full border-b-2`}>
            <div className='cursor-pointer flex justify-between py-8 md:py-12 md:px-4 items-center relative' onClick={() => setIsOpen(!isOpen)}>
                <h3 className='font-bold text-gray-500'>
                    <span className='mr-2'>{index}</span>
                    {item}
                </h3>
                <div className='mr-4'>
                    <span className={`absolute transform -translate-x-1/2 -translate-y-1/2 transition-all duration-300 ease-in-out ${!isOpen && 'rotate-180'}`}>
                        <AccordionArrow />
                    </span>
                </div>
            </div>
            {isOpen && (
                <div className='-mt-6 overflow-x-auto mb-6'>
                    <TreeView data={data} item={item} />
                </div>
            )}
        </div>
    )
}

export default Accordion
